import { post } from '@core/api/baseApi';
import { PostOrganizationTemplateResponse } from '@core/types/ApiResponses';

const setOrganizationTemplates = (formData: FormData): Promise<PostOrganizationTemplateResponse> => post(`/organizations/templates`, formData);

export default setOrganizationTemplates;
